import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BaseStepFormComponent } from 'src/app/system-common/base-step-form/base-step-form.component';
import { AgentService } from '../services/agent.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { StepItem } from 'src/app/models/common/step-item';
import { PageHeader } from 'src/app/models/common/page-header';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { Location } from '@angular/common';

@Component({
  selector: 'sym-agent-test-api-step-form',
  templateUrl: './agent-test-api-step-form.component.html',
  styleUrls: ['./agent-test-api-step-form.component.scss'],
})
export class AgentTestApiStepFormComponent
  extends BaseStepFormComponent<AgentService>
  implements OnInit, OnChanges
{
  options = [];
  public apiResponseData = null;
  public responseUpdated = false;
  public apiRequestData = { value: null };
  public scrollPosition = 0;
  public displayPopupApiResponse: boolean;
  public successResponse: any;
  @Input() restApiDataInfo: any;
  public createQuotationCallCounter = 0; //to solve guid duplication issue,create new guid if counter gretter than 1.

  constructor(
    service: AgentService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    public offlineService: OfflineService,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['restApiDataInfo'] && changes['restApiDataInfo'].currentValue) {
      setTimeout(() => {
        this.headerService.pageHeader = this.getPageHeader();
        if (this.restApiDataInfo.screenReqdFl == 'NO') this.restApiCall(this.restApiDataInfo.apiName);
        this.displayPopupApiResponse = false;
      }, 10);
    }
  }

  getStepList(): StepItem[] {
    let stepList: StepItem[] = [
      new StepItem(
        0,
        'step_testApiDetails',
        [
          {
            id: 'tab_basic',
            modelList: [
              'Entity',
              'AgentParty',
              'AgentDetail',
              'RelativesList',
              'PaymentList',
              'EducationList',
              'TrainingList',
              'ExamList',
              'DocumentCategoryList',
              'DocumentList',
              'DocumentImageList',
              'PartyOccupation',
              'NotesModel',
              'ServiceSignatureList',
            ],
          },
        ],
        ['but_Request']
      ),
    ];

    return stepList;
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Agent : Test Api';
    if (this.restApiDataInfo != undefined) {
      header.title = 'Agent : ' + this.restApiDataInfo.apiDesc + ' API';
      header.additionalInfo = '( ' + this.restApiDataInfo.apiInfoDetails + ' )';
    }
    if (
      this.service.responseIO != undefined &&
      this.service.responseIO.data['BasePlan'] != undefined &&
      ((this.service.responseIO.data['BasePlan'].productSeq != undefined &&
        this.service.responseIO.data['BasePlan'].productSeq != null) ||
        (this.service.responseIO.data['BasePlan'].productId != undefined &&
          this.service.responseIO.data['BasePlan'].productId != null))
    ) {
      let productDesc = this.service.responseIO.data['BasePlan'].productLongName;
      header.title = header.title + ' for ' + productDesc;
    }

    return header;
  }

  protected postInit() {
    super.postInit();
    this.service.responseIO['isMetadataHelpReqd'] = false;
  }

  protected postLoad() {
    super.postLoad();
    this.service.responseIO['isMetadataHelpReqd'] = false;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'home',
        link: '/home',
      },
    ];
  }

  async sendRequest(tempRequest) {
    let apiName = this.restApiDataInfo.apiName;
    if (tempRequest.value != undefined) {
      this.apiRequestData.value = tempRequest.value;
    }

    //in save policy api,copy response data into request data,so solve row was updated issue.
    if (apiName == 'saveQuotation') {
      let apiRequestData = JSON.parse(this.apiRequestData.value);
      let apiResponseData = JSON.parse(this.apiResponseData);
      apiRequestData.body.FormData.Models = apiResponseData.data;
      this.apiRequestData.value = JSON.stringify(apiRequestData, null, '\t');
    } else if (apiName == 'createQuotation') {
      //this.updateQuotationGuid(true);
    }
    this.apiResponseData = undefined;
    this.apiResponseData = await this.service.sendRequest(this.apiRequestData.value, this.scrollPosition);
    //in save policy api,copy response data into service response io,so solve row was updated issue.
    if (apiName == 'saveQuotation' || apiName == 'getQuotation') {
      this.service.responseIO = JSON.parse(this.apiResponseData);
      this.service.responseIO.isMetadataHelpReqd = true;
    }
  }

  but_Request_click() {
    if (this.restApiDataInfo.apiName == undefined || this.restApiDataInfo.apiName == 'null') {
      this.warn('Please select a valid Api', undefined, true);
      return;
    }
    this.restApiCall(this.restApiDataInfo.apiName);
  }

  successApiResponse(successResponse: Object, trimRequestReq: boolean) {
    if (trimRequestReq) this.service.trimRequest();
    this.apiRequestData.value = JSON.stringify(this.service.httpReq, null, '\t');
    this.apiResponseData = JSON.stringify(successResponse, null, '\t');
    this.displayPopupApiResponse = true;
    this.openModal('apiRequest');
    if (this.restApiDataInfo != undefined && this.restApiDataInfo.screenReqdFl == 'NO') {
      this.openPopup('defaultPopup');
    }
  }

  errorApiResponse(error: any) {
    this.error(error.error);
    this.apiResponseData = undefined;
    this.displayPopupApiResponse = true;
    console.log('Error:', error);
    this.openModal('apiRequest');
  }

  restApiCall(selectedApiCd: string) {
    try {
      eval('this.' + selectedApiCd + '()');
    } catch (e) {
      this.error('Initialization error. Please select another API and try again.' + e);
    }
  }

  getAgent(): void {
    let id = 190310;
    let modelList: [
      'Entity',
      'AgentParty',
      'AgentDetail',
      'RelativesList',
      'PaymentList',
      'EducationList',
      'TrainingList',
      'ExamList',
      'DocumentCategoryList',
      'DocumentList',
      'DocumentImageList',
      'PartyOccupation',
      'NotesModel',
      'ServiceSignatureList'
    ];
    this.service.getAgent(id, modelList, true).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  getProductionName(): void {
    this.service.getProductionName().subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  getGenderForTitle(): void {
    let title = 'MR';
    let respGender: any;
    let body = {
      mappingKey: 'TitleGender',
      drivingValue: title,
    };
    this.service
      .httpPost(`${this.service.getURLValue('LOOKUP')}/loadMappingData`, body, undefined, false)
      .subscribe(
        (successResponse) => {
          this.successApiResponse(successResponse, false);
        },
        (error) => {
          this.errorApiResponse(error);
        }
      );
  }

  addImage(): void {
    let document = this.service.getModelNameBodyList(['DocumentList']);
    let imageContent = 'xyz';
    let id = 190313;
    let body = {};
    if (document['ocrCheckReqd'] == 'YES') {
      body = {
        imageContent: imageContent,
        serviceDocument: document,
      };
    }

    let path = this.service.getURLValue('AGENT');
    this.service.httpPost(`${path}/${id}/addImage`, body).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  populateOCRData(): void {
    let imageContent = 'xyz';

    let body = {
      ImageContent: imageContent,
      Party: this.service.getModelNameBodyList(['AgentParty']),
    };
    let path = this.service.getURLValue('AGENT');
    this.service.httpPost(`${path}/populateOCRData`, body, null, true).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  getAgentApplicationStatus(): void {
    this.service.getAgentApplicationStatus().subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  getAgentProductionSummary(): void {
    this.service.getAgentProductionSummary('WRP', 3, 2023).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  getAgentPerformanceStatus(): void {
    this.service.getAgentPerformanceStatus('M', '19-Jan-2024', '19-Jul-2024').subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  getAgentPerformance(): void {
    this.service.getAgentPerformance('WRP', 12, 2023).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  getCustomAgentPerformance(): void {
    this.service.getCustomAgentPerformance('PREMIUMCOLLECTED', '2024-03-01', '2024-05-31', 'M', 5, 2024).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  getAgentProfile(): void {
    let id = 190322;
    this.service.getAgentProfile(id).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  deleteAgent(): void {
    let id = 190325;
    this.service.deleteAgent(id).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  deleteAgents(): void {
    let ids = [190323, 190324];

    this.service.deleteAgents(ids).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  getNoteHistory(): void {
    let entityGuid = '17ce4b022cbe1e0768cfa9cd0001e02e';

    this.service.getNoteHistory(entityGuid).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  addNote(): void {
    let entityGuid = '17ce4b022cbe1e0768cfa9cd0001e02e';

    this.service.addNote(entityGuid).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  saveNote(): void {
    let respData = {
      guid: '190cad4a2cbe1afe2708f1f000008143',
      id: null,
      status: 'N',
      versionID: 1,
      isObjectSelected: null,
      transactionStatusCd: null,
      entityTypeCd: null,
      previousEntityStatus: null,
      entityDesc: null,
      systemCreatedDt: null,
      systemUpdatedDt: null,
      companyCd: null,
      visitedTabs: null,
      entityStatus: null,
      notesTypeCd: null,
      notesSubject: null,
      notesContent: 'gvdwvffreh',
      notesCategoryCd: null,
      entityGuid: '190ca7c0280d031e3125ea000005f26a',
      notesEntryDt: '2024-07-19T11:51:04.643Z',
      notesEnteredByUser: 'CHECKER',
      taskCd: null,
      privilegeCd: null,
      userId: null,
      removed: '',
      entityLocation: '',
      entityNumber: '',
    };

    this.service.saveNote(respData).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  getDashboardBalance(): void {
    let body = {};
    let path = '/api/dashboardBalance';

    this.service.httpPost(`${path}/getDashboardBalance`, body).subscribe(
      (successResponse) => {
        this.successApiResponse(successResponse, false);
        console.log(successResponse);
        this.successResponse = successResponse;
      },
      (error) => {
        this.errorApiResponse(error);
      }
    );
  }

  getSourceName(): void {
    let sourceName = '8888';
    let sourceNum: any;
    let body = {
      onlineLookupKey: 'EMPLOYEEHIERARCHY',
      onlineFilterCond: {
        'hierarchyDO.employeeCode': sourceName,
      },
      offlineLookupKey: 'EMPLOYEEHIERARCHY',
      offlineFilterCond: {
        sourceName: sourceName,
      },
    };
    this.service
      .httpPost(`${this.service.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false)
      .subscribe(
        (successResponse) => {
          this.successApiResponse(successResponse, false);
          console.log(successResponse);
          this.successResponse = successResponse;
        },
        (error) => {
          this.errorApiResponse(error);
        }
      );
  }

  getReferenceName(): void {
    let referName = '8888';
    let referNum: any;
    let body = {
      onlineLookupKey: 'EMPLOYEEHIERARCHY',
      onlineFilterCond: {
        'hierarchyDO.employeeCode': referName,
      },
      offlineLookupKey: 'EMPLOYEEHIERARCHY',
      offlineFilterCond: {
        referName: referName,
      },
    };

    this.service
      .httpPost(`${this.service.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false)
      .subscribe(
        (successResponse) => {
          this.successApiResponse(successResponse, false);
          console.log(successResponse);
          this.successResponse = successResponse;
        },
        (error) => {
          this.errorApiResponse(error);
        }
      );
  }

  getReportingName(): void {
    let reportName = '8888';
    let reportNum: any;
    let body = {
      onlineLookupKey: 'EMPLOYEEHIERARCHY',
      onlineFilterCond: {
        'hierarchyDO.employeeCode': reportName,
      },
      offlineLookupKey: 'EMPLOYEEHIERARCHY',
      offlineFilterCond: {
        reportName: reportName,
      },
    };

    this.service
      .httpPost(`${this.service.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false)
      .subscribe(
        (successResponse) => {
          this.successApiResponse(successResponse, false);
          console.log(successResponse);
          this.successResponse = successResponse;
        },
        (error) => {
          this.errorApiResponse(error);
        }
      );
  }

  getReportBranchCode(): void {
    let ReportName = '8888';
    let branchCodeFromReport: any;
    let body = {
      onlineLookupKey: 'EMPLOYEEHIERARCHY',
      onlineFilterCond: {
        'hierarchyDO.employeeCode': ReportName,
      },
      offlineLookupKey: 'EMPLOYEEHIERARCHY',
      offlineFilterCond: {
        ReportName: ReportName,
      },
    };

    this.service
      .httpPost(`${this.service.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false)
      .subscribe(
        (successResponse) => {
          this.successApiResponse(successResponse, false);
          console.log(successResponse);
          this.successResponse = successResponse;
        },
        (error) => {
          this.errorApiResponse(error);
        }
      );
  }
}
